import { Button } from "@mui/material";
import propTypes from "prop-types";

export default function AdjustButtons({
  variant = "outlined",
  includeHalf = false,
  step = 1,
  disablePadding = false,
  size = "medium",
  isIncrement = false,
  direction = "row",
  onAdjust = () => {},
}) {
  const buttonLabel = isIncrement ? "Lisää" : "Vähennä";
  const buttonSymbol = isIncrement ? "+" : "-";

  const handleAdjust = (value) => onAdjust(isIncrement ? value : -value);

  const styles = {
    button: {
      borderRadius: "10px",
      opacity: "0.7",
    },
    buttonContainer: {
      padding: disablePadding ? 0 : size === "small" ? "2px" : "6px",
    },
    container: {
      display: "flex",
      flexDirection: direction,
      justifyContent: "space-evenly",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.buttonContainer}>
        <Button
          variant={variant}
          onClick={() => handleAdjust(step)}
          aria-label={`${buttonLabel} yksi`}
          sx={styles.button}>
          {buttonSymbol}
          {step}
        </Button>
      </div>
      {includeHalf && (
        <div style={styles.buttonContainer}>
          <Button
            variant={variant}
            onClick={() => handleAdjust(step / 2)}
            aria-label={`${buttonLabel} puoli`}
            sx={styles.button}>
            {buttonSymbol}
            {step === 1 ? <>&#189;</> : (step / 2).toFixed(1)}
          </Button>
        </div>
      )}
    </div>
  );
}

AdjustButtons.propTypes = {
  isIncrement: propTypes.bool,
  onAdjust: propTypes.func.isRequired,
  direction: propTypes.oneOf(["column", "row"]),
  size: propTypes.oneOf(["small", "medium", "large"]),
  includeHalf: propTypes.bool,
  variant: propTypes.string,
  step: propTypes.number,
  disablePadding: propTypes.bool,
};
